import { Button, Stack, Typography } from "@mui/material";
import compInfos from "./user-fine-header.json";
import { useLangContext } from "../../../../context/langContext";
import { useFilesContext } from "../../../../context/myFilesContext";
import { AddSquare } from "iconsax-react";

export default function UserFilesHeaderComponent() {
  const { lang } = useLangContext();
  const { setNewUploadOpen } = useFilesContext();
  const infos = compInfos[lang];
  return (
    <Stack direction={"column"} width="100%">
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ md: "center", xs: "start" }}
        mb="16px"
        width="100%"
      >
        <Stack>
          <Typography
            variant="h4DemiBold"
            color={({ palette }) => palette.dominant.main}
            sx={{
              mb: "4px",
              mt: { xs: "0px", sm: "24px" },
            }}
          >
            {infos.title}
          </Typography>
          <Typography
            variant="footerDemiBold"
            color={({ palette }) => palette.complement[300]}
            sx={{
              mb: "20px",
            }}
          >
            {infos.subtitle}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={{ md: "space-between", xs: "center" }}
          width={{ xs: "100%", sm: "initial" }}
          gap={{ md: "12px", xs: "6px" }}
        >
          {/* <Button
            onClick={() => setNewUploadOpen(true)}
            variant="contained"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: { xs: "6px", md: "10px" },
            }}
          >
            <AddSquare size="20" />
            {infos.buttonOne}
          </Button> */}
        </Stack>
      </Stack>
    </Stack>
  );
}
